export default "__VITE_ASSET__B9QvegB0__"